import network from '@/services/network';
import { ErrorResponse } from '@/utils';
import { Stoerfall, StoerfallListe, StoerfallTeamUebersicht } from '@/types/stoerfall';

/**
 * Störfälle aus iPlanner (docs/tasks/stoerfaelle.md, ANB = Störfall-Liste).
 * Sichtbarkeit rechnet der Server: VP eigene, Führungskräfte alle, nur mit
 * BW-Kunde.
 */
const offene = async (): Promise<StoerfallListe> => {
  try {
    const { data } = await network.get<StoerfallListe>('/stoerfaelle');
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

/** Leadership-Cockpit: offene Störfälle aktiver VPs je Team und Art (Alex 28.10.2026). */
const teams = async (): Promise<StoerfallTeamUebersicht> => {
  try {
    const {
      data: { data },
    } = await network.get<{ data: StoerfallTeamUebersicht }>('/stoerfaelle/teams');
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

/** Die Fälle hinter einer Zeile der Team-Übersicht (Team-ID oder `ohne`, optional Art). */
const teamListe = async (team: string, art?: string): Promise<StoerfallListe> => {
  try {
    const { data } = await network.get<StoerfallListe>('/stoerfaelle/teams/liste', { params: { team, art } });
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const fuerKunde = async (customerId: number): Promise<StoerfallListe> => {
  try {
    const { data } = await network.get<StoerfallListe>(`/stoerfaelle/kunde/${customerId}`);
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const erledigen = async (stoerfallId: number): Promise<Stoerfall> => {
  try {
    const {
      data: { data },
    } = await network.post<{ data: Stoerfall }>(`/stoerfaelle/${stoerfallId}/erledigen`);
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const stoerfaelleApi = {
  offene,
  teams,
  teamListe,
  fuerKunde,
  erledigen,
};

export default stoerfaelleApi;
